import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {apiQuery} from "../../utils/AppConfig";
import {Response} from "../../types/response/Response";
import {EmployeeDTO} from "../../types/employee/EmployeeDTO";

export const employeeApi = createApi({
    reducerPath: 'employee',
    baseQuery: apiQuery,
    tagTypes: ["employee"],
    endpoints: builder => ({
        getSelfEmployee: builder.query<Response<EmployeeDTO>, void>({
            query: () => '/employees/self',
            providesTags: ['employee']
        })
    })
})

export const {useGetSelfEmployeeQuery} = employeeApi